import React from 'react';
import { CheckCircle, AlertCircle, FileText } from 'lucide-react';

const VerificationTab = ({ vendor, vendorProfile, userVerifications, formatDate }) => {
 return (
 <div className="space-y-6">
 <div>
 <h3 className="text-lg font-medium text-gray-900 mb-4">Verification Status</h3>
 <div className="bg-surface-muted rounded-lg p-4">
 <div className="flex items-center justify-between">
 <div className="flex items-center">
 {vendorProfile?.is_verified ? (
 <CheckCircle className="w-6 h-6 text-green-600 mr-3" />
 ) : (
 <AlertCircle className="w-6 h-6 text-yellow-600 mr-3" />
 )}
 <div>
 <p className="text-sm font-medium text-gray-900">
 {vendorProfile?.is_verified ? 'Verified' : 'Pending Verification'}
 </p>
 <p className="text-sm text-gray-500">
 {vendorProfile?.is_verified 
 ? `Verified on ${formatDate(vendorProfile.updated_at)}`
 : 'Awaiting admin approval'
 }
 </p>
 </div>
 </div>
 <div className="text-right">
 <p className="text-sm text-gray-500">Verification Level</p>
 <p className="text-sm font-medium text-gray-900">
 {vendor.verification_level || 'Basic'}
 </p>
 </div>
 </div>
 </div>
 </div>

 {userVerifications.length > 0 && (
 <div>
 <h3 className="text-lg font-medium text-gray-900 mb-4">Verification Documents</h3>
 <div className="space-y-4">
 {userVerifications.map((verification, index) => {
 let documents = [];
 try {
 const docData = JSON.parse(verification.verification_document_url || '{}');
 documents = Object.entries(docData).map(([type, url]) => ({
 type: type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
 url: url
 }));
 } catch (e) {
 console.error('Error parsing verification documents:', e);
 }

 return (
 <div key={index} className="border border-gray-200 rounded-lg p-4">
 <div className="flex items-center justify-between mb-3">
 <div className="flex items-center">
 <FileText className="w-5 h-5 text-gray-400 mr-3" />
 <div>
 <p className="text-sm font-medium text-gray-900">
 {verification.verification_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
 </p>
 <p className="text-sm text-gray-500">
 Submitted on {formatDate(verification.created_at)}
 </p>
 </div>
 </div>
 <span className={`px-2 py-1 text-xs rounded-full ${ verification.verification_status === 'approved' ? 'bg-green-100 text-green-800' : verification.verification_status === 'rejected' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800' }`}>
 {verification.verification_status}
 </span>
 </div>
 
 {verification.admin_notes && (
 <div className="mb-3 p-2 bg-surface-muted rounded text-sm text-gray-700">
 <span className="font-medium">Admin Notes:</span> {verification.admin_notes}
 </div>
 )}

 {documents.length > 0 && (
 <div className="space-y-2">
 <p className="text-sm font-medium text-gray-700">Uploaded Documents:</p>
 <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
 {documents.map((doc, docIndex) => (
 <div key={docIndex} className="flex items-center justify-between p-2 bg-surface-muted rounded">
 <span className="text-sm text-gray-700">{doc.type}</span>
 <a 
 href={doc.url} 
 target="_blank" 
 rel="noopener noreferrer"
 className="text-ink hover:text-ink text-sm"
 >
 View Document
 </a>
 </div>
 ))}
 </div>
 </div>
 )}
 </div>
 );
 })}
 </div>
 </div>
 )}
 </div>
 );
};

export default VerificationTab;

